module.exports = __webpack_public_path__ + "img/服務條款4.3a8f4f70.png";